@import "../../../../../shared/styles/base";

// This class name is referenced in the 'Long-text preview chip'
.c-chip {
  display: inline-flex;
  align-items: center;

  // TODO: Remove padding/margin layout from the chip itself and add to a container
  margin: 0 0.5rem 0 0;
  padding: 0;
  background: $ds-neutral-200;
  border-radius: 0.25rem;
  overflow: hidden;
  min-height: 2em;

  appearance: none;
  border: none;

  font-size: $ds-font-size-b1;

  &__content {
    display: flex;
    align-items: center;
    padding: 0 0.5em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: none;
  }

  &__remove-button {
    appearance: none;
    border: none;
    background: none;

    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 0.25em 0 0;
    padding: 0.25rem;

    border-radius: 1.25rem;
    cursor: pointer;
    color: currentColor;
  }

  &__suffix {
    padding: 0 0.5em;
    display: flex;
    margin-left: 0.25em;
    align-items: center;
    align-self: stretch;
  }

  &.is-danger {
    background-color: $ds-coral-50;
    color: $ds-coral-900;
  }

  &.is-success {
    background-color: $ds-jade-50;
    color: $ds-jade-900;
  }

  &.is-warning {
    background-color: $ds-mustard-50;
    color: $ds-mustard-900;
  }

  &.is-info {
    background-color: $ds-teal-50;
    color: $ds-teal-900;
  }

  &.is-info &__suffix {
    background-color: $ds-teal-300;
  }

  .c-loading-spinner {
    margin-left: 0.5em;
  }
}

button.c-chip {
  cursor: pointer;
}

.c-chip-container {
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5rem;
}
